export default __webpack_public_path__ + "static/media/GothamBoldItalic.e1d2f765.ttf";